<!-- Modern AI Chatbot Layout - Gemini Inspired -->
<div class="chat-container flex h-screen relative" (click)="onContainerClick()">
  <!-- Mobile Menu Overlay -->
  @if (isMobileMenuOpen) {
    <div
      class="fixed inset-0 bg-black/50 z-10 md:hidden"
      (click)="isMobileMenuOpen = false"
    ></div>
  }

  <!-- Sidebar Component -->
  <app-sidebar
    #sidebar
    [isMobileMenuOpen]="isMobileMenuOpen"
    [publicNavigationItems]="publicNavigationItems"
    [rbacNavigationItems]="rbacNavigationItems"
    [user]="user"
    [isDarkTheme]="isDarkTheme"
    (toggleMobileMenu)="isMobileMenuOpen = !isMobileMenuOpen"
    (toggleTheme)="toggleTheme()"
    (navigate)="navigate($event)"
  ></app-sidebar>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col overflow-hidden bg-light-bg dark:bg-dark-bg">
    <!-- Mobile Header Component -->
    <app-mobile-header
      [currentPage]="currentPage"
      (toggleMenu)="isMobileMenuOpen = true"
    ></app-mobile-header>

    <!-- Page Content -->
    <div class="flex-1 overflow-auto">
      <ng-content></ng-content>
    </div>
  </div>
</div>
